import React from 'react';
import PanelGroup  from 'react-bootstrap/lib/PanelGroup';
import ServicePartSectionPanel from './ServicePartSectionPanel';

export default class ServiceConfigurator extends React.Component{

    constructor(props) {
        super(props);
        this.state = { activePanelKey: 0 };
    }

    handlePanelClick(key) {
        this.setState({ activePanelKey: key });
    }

    render () {
        const panels = this.props.serviceSectionPartConfigs.map((partsSection, index) =>  {
            return <ServicePartSectionPanel id={partsSection.id}
                                            key={partsSection.id}
                                            handleSelect={this.handlePanelClick.bind(this)}
                                            eventKey={index}
                                            partsSection={partsSection}
                                            expanded={this.state.activePanelKey === index}
                                            togglePart={this.props.togglePart}
                                            onSelectedPartsChanged={this.props.onSelectedPartsChanged}/>
        });

        return <PanelGroup activeKey={this.state.activePanelKey}>
            {panels}
         </PanelGroup>
    }
}
